function initFormFieldSelectPicker(){
  $('.custom-field-select').each(function(index, element) {
    const isInitiated = $(element).attr('is-initiated');

    if (isInitiated) {
      return;
    }

    $(element).attr('is-initiated', true);

    const prevElement = $(element).prev('.temprorary-select');
    if (prevElement[0]) prevElement[0].classList.add('d-none');

    $(element).selectpicker('setStyle', 'btn-light', 'remove').selectpicker('setStyle', 'btn', 'remove');

    const parentElement = $(element).parent('.bootstrap-select');
    const valueHolderElement = $(parentElement).find('.filter-option-inner-inner');
    
    // Transfer title attribute to the generated button
    const titleAttr = $(element).attr('titleAttribute');
    if (titleAttr) {
      $(parentElement).find('.dropdown-toggle').attr('title', titleAttr);
    }

    if (!$(element).val().length) {
      $(valueHolderElement).addClass('empty-value')
    }
    $(element).on('changed.bs.select', function (e) {
      if (e.target.value === '') {
        $(valueHolderElement).addClass('empty-value')
      } else {
        $(valueHolderElement).removeClass('empty-value')
      }
      
      // Preserve title attribute after change
      if (titleAttr) {
        $(parentElement).find('.dropdown-toggle').attr('title', titleAttr);
      }
    });

    // Add event listener for Enter or Space to toggle the dropdown
    $(parentElement).on('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault(); // Prevent default behavior

        if (!$(parentElement).hasClass('show')) {
          $(element).selectpicker('toggle'); // Open the dropdown if it's closed
        }
      }
    });
  });
}

$(function () {
  initFormFieldSelectPicker();

  document.addEventListener('jb.section.rendered', () => {
    initFormFieldSelectPicker();
  });

  document.addEventListener('section.initiated', () => {
    initFormFieldSelectPicker();
  });
});

